<div class="modal fade in document-attach-viewer" [ngStyle]="isPatientUser() ? {} : {}" [class.fullscreen]="document_service.is_fullscreen" *ngIf="document_service.is_fullscreen">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" *ngIf="document_service.is_pchf == false">
        <a class="fa fa-times fs20 text-black pull-right" (click)="trigger_preview_closed()"></a>
        <h3 class="m0 text-center">{{document_service.document_name()}}</h3>
        <span class="input-field">
          <input #current_page class="form-control" type="text" name="current_page" [ngModel]="document_service.selected_page" (change)="gotoPage($event,current_page.value)">
          <span class="total-pages">of {{document_service.total_pages}}</span>
        </span>
      </div>
      <div class="modal-body scroll-browser document_viewer" #document_container (scroll)="page_scrolling($event)">

        <!-- Loaded attachments (e.g. chart documents via openViewer) -->
        <ul class="list-unstyled m0" *ngIf="isLoadedAttachment">
          <li *ngFor="let page of document_service.pages;let i = index" [attr.page_number]="i+1" [id]="'page_'+(i+1)" class="page">

            <!-- XML / C-CDA document -->
            <ng-container *ngIf="page.is_xml()">
              <!-- Loading state -->
              <div class="ccda-loading text-center p-lg" *ngIf="page.ccdaLoading">
                <i class="fa fa-spinner fa-spin fs20 text-muted"></i>
                <p class="text-muted mt-sm fs12">Rendering clinical document…</p>
              </div>
              <!-- Error state -->
              <div class="ccda-error text-center p-lg" *ngIf="page.ccdaError && !page.ccdaLoading">
                <i class="fa fa-exclamation-triangle fs20 text-warning"></i>
                <p class="text-muted mt-sm fs12">Could not render this document.</p>
                <a [href]="page.url" target="_blank" class="btn btn-default btn-sm btn-outline mt-xs">
                  <i class="fa fa-download mr-xs"></i>Download original file
                </a>
              </div>
              <!-- Rendered iframe -->
              <iframe *ngIf="page.ccdaHtml && !page.ccdaLoading"
                      [srcdoc]="page.ccdaHtml | safeHtml"
                      class="ccda-iframe"
                      sandbox="allow-same-origin"
                      title="Clinical Document">
              </iframe>
            </ng-container>

            <!-- Image pages -->
            <img [src]="page.url" [alt]="page.text" *ngIf="!page.is_xml() && page.url" class="img-responsive page-img">
            <span class="page-counter" *ngIf="!page.is_xml()">Page - {{i+1}} / {{document_service.total_pages}}</span>
          </li>
        </ul>

        <!-- Lazily-loaded attachments (legacy flow via loadAttachment) -->
        <ul class="list-unstyled m0" *ngIf="!isLoadedAttachment">
          <li *ngFor="let page of document_service.pages;let i = index" [attr.page_number]="i+1" [id]="'page_'+(i+1)" class="page">

            <!-- XML / C-CDA document -->
            <ng-container *ngIf="page.is_xml()">
              <div class="ccda-loading text-center p-lg" *ngIf="page.ccdaLoading">
                <i class="fa fa-spinner fa-spin fs20 text-muted"></i>
                <p class="text-muted mt-sm fs12">Rendering clinical document…</p>
              </div>
              <div class="ccda-error text-center p-lg" *ngIf="page.ccdaError && !page.ccdaLoading">
                <i class="fa fa-exclamation-triangle fs20 text-warning"></i>
                <p class="text-muted mt-sm fs12">Could not render this document.</p>
                <a [href]="page.url" target="_blank" class="btn btn-default btn-sm btn-outline mt-xs">
                  <i class="fa fa-download mr-xs"></i>Download original file
                </a>
              </div>
              <iframe *ngIf="page.ccdaHtml && !page.ccdaLoading"
                      [srcdoc]="page.ccdaHtml | safeHtml"
                      class="ccda-iframe"
                      sandbox="allow-same-origin"
                      title="Clinical Document">
              </iframe>
            </ng-container>

            <img [src]="page.url" [alt]="page.text" *ngIf="!page.is_xml() && page.loaded && page.is_image()" class="img-responsive page-img">
            <video controls *ngIf="!page.is_xml() && page.is_video()">
              <source [src]="page.url">
              Your browser does not support the video tag.
            </video>
            <audio controls *ngIf="!page.is_xml() && page.is_audio()">
              <source [src]="page.url">
              Your browser does not support the video tag.
            </audio>
            <div class="border-box text-center p-sm text-tertiary" *ngIf="!page.is_xml() && !page.loaded">
              <i class="fa fa-spinner fa-spin"></i>&nbsp; {{page.text}}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
